import { watch } from "vue";
import {
  THEME_BLUE,
  THEME_CYAN,
  THEME_GREEN,
  THEME_ORANGE,
} from "@/data/constants";
import { channelsRouteNames } from "@/modules/channels/routes";
import {
  contentRoutesNames,
  contentRouteBasePath,
} from "@/modules/content/routes";
import { productRoutesNames } from "@/modules/products/routes";
import { reportsRoutesNames } from "@/modules/reports/routes";
import router from "@/router";

const checkIfActive = (path: string) => {
  return new RegExp(`^/[^/]+/${path}`).test(router.currentRoute.value.path);
};

watch(
  () => router.currentRoute.value.path,
  () => {
    contentItem.active = checkIfActive(contentRouteBasePath);
  },
);

const productItem = {
  title: "Products",
  icon: "$Package",
  link: router.resolve({
    name: productRoutesNames.list(),
  }),
  routeName: "products",
  theme: THEME_GREEN,
};

const reportItem = {
  title: "Reports",
  icon: "$Strategy",
  link: router.resolve({
    name: reportsRoutesNames.list(),
  }),
  routeName: "reports",
  theme: THEME_CYAN,
};

const contentItem = {
  title: "Content",
  icon: "$Template",
  link: router.resolve({
    name: contentRoutesNames.lists.root,
  }),
  routeName: contentRoutesNames.lists.root,
  theme: THEME_BLUE,
  active: checkIfActive(contentRouteBasePath),
};

const channelItem = {
  title: "Channels",
  icon: "$ArrowsRightLeft",
  link: router.resolve({
    name: channelsRouteNames.root,
  }),
  routeName: channelsRouteNames.root,
  theme: THEME_ORANGE,
};

const drawerDefaultItems = () => {
  return [productItem, reportItem, contentItem, channelItem];
};

export {
  productItem,
  reportItem,
  contentItem,
  channelItem,
  drawerDefaultItems,
};
